import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'compact' | 'featured';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors duration-200"
      >
        <div className="w-20 h-20 flex-shrink-0 rounded-md overflow-hidden">
          <img src={article.coverImage} alt={article.title} className="w-full h-full object-cover" title={`亲吻姐姐 - ${article.title}`} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-heading font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
            {article.title}
          </h4>
          <p className="text-xs text-foreground-500 mt-1.5 font-body flex items-center gap-3">
            <span>{article.publishDate}</span>
            <span>{article.readTime}</span>
          </p>
        </div>
      </Link>
    );
  }

  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300"
      >
        <div className="relative h-52 overflow-hidden">
          <img src={article.coverImage} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" title={`亲吻姐姐 - ${article.title}`} />
          <div className="absolute top-3 left-3">
            <span className="px-2.5 py-1 text-xs font-body rounded-full bg-primary-500 text-background-50 dark:text-foreground-950">
              {article.category === 'plot-analysis' ? '剧情解析' :
               article.category === 'characters' ? '角色介绍' :
               article.category === 'voice-actors' ? '声优阵容' :
               article.category === 'ova' ? 'OVA特辑' : '名场面'}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 mt-2 line-clamp-2 font-body leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center gap-3 mt-4 text-xs text-foreground-500 font-body">
            <span>{article.publishDate}</span>
            <span className="text-foreground-300">·</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300"
    >
      <div className="relative h-44 overflow-hidden">
        <img src={article.coverImage} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" title={`亲吻姐姐 - ${article.title}`} />
        <div className="absolute top-2.5 left-2.5">
          <span className="px-2 py-0.5 text-xs font-body rounded-full bg-primary-500/90 text-background-50 dark:text-foreground-950">
            {article.category === 'plot-analysis' ? '剧情解析' :
             article.category === 'characters' ? '角色介绍' :
             article.category === 'voice-actors' ? '声优阵容' :
             article.category === 'ova' ? 'OVA特辑' : '名场面'}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 font-body leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500 font-body">
          <span>{article.publishDate}</span>
          <span className="text-foreground-300">·</span>
          <span>{article.readTime}</span>
        </div>
      </div>
    </Link>
  );
}